<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" :class="childclass">

          <div class="modal-header" v-if="$slots.header">
            <slot name="header">
              default header
            </slot>
          </div>

          <div class="modal-body" v-if="$slots.body">
            <slot name="body">
              default body
            </slot>
          </div>

          <div class="modal-footer" v-if="$slots.footer">
            <slot name="footer">
              default footer
            </slot>
            <div class="modal-default-button" @click="$emit('close')">x</div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'modal',

    data() {
      return {
        open: false
      }
    },

    props: {
      title: {
        type: String,
        default: 'title'
      },
      animation: {
        type: String,
        default: 'reveal'
      },
      childclass: {
        type: Object,
      },
    }
  }
</script>

<style scoped lang="scss">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 1px;
  min-width: 90%;
  height: auto;
  text-align: center;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: var(--white);
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: var(--roboto);
  overflow: hidden;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
  display: block;
  cursor: pointer;
  font-size: 2em;
  margin-top: -25px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-container.small {
  height: auto;
  border-bottom: 10px solid black;
}

@media only screen and (min-width:800px) {
  .modal-container {
    width: 1px;
    min-width: 70%;
  }

  .modal-container.small {
    min-width: 42%;
  }
}
</style>
